import CustomErrorInstance from 'custom-error-instance';

import SigniappError from './SigniappError.js';

const AccessDenied = CustomErrorInstance('AccessDenied', SigniappError);

export default AccessDenied;
